module.exports = __webpack_public_path__ + "assets/img/life-5.7ed1acf2.jpg";